import Ajax from 'js/utils/ajax/ajax';

export const editShipment = (trackingReference, shipment) =>
  Ajax.patch(`/orders/v2/${trackingReference}/shipment`, shipment);
